module.exports = __webpack_public_path__ + "static/img/hotel-karosta-4.151ff4b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/articles/1911262/hotel-karosta-4.jpg
// module id = Yo0e
// module chunks = 1